module.exports = __webpack_public_path__ + "static/EnmTX_BosRussell_L_B_cl-94ae3053f534aff087c118162175b2bb.gif";